<template>
  <div class="error">
    <h2>404 Not Found</h2>
    <p>找不到這個頁面</p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.error {
  max-width: 250px;
  margin: auto;
  text-align: center;
}
</style>
